import { connect } from 'react-redux';
import { selectIsMobile } from 'redux/modules/device';
import { SecondaryFilters } from './SecondaryFilters';
import { selectActiveLocation } from '../SearchBox/SearchBox.reducer';
import { selectResultType, selectSelectedVertical } from './filters.helpers';

export const mapStateToProps = state => {
  const resultType = selectResultType(state);
  const { isMapSearch } = selectActiveLocation(state) || {};
  const selectedVertical = selectSelectedVertical(state);

  return {
    vertical: selectedVertical,
    resultType,
    hideRadiusFilter: isMapSearch,
    isMobile: selectIsMobile(state),
  };
};

export const SecondaryFiltersContainer = connect(mapStateToProps)(SecondaryFilters);
